import { useState } from 'react';
import regalaAventura from '../assets/regala-aventura.png';
import regalaEscapada from '../assets/regala-escapada.png';
import regalaSemana from '../assets/regala-semana.png';

export function GiftCard() {
  const [selectedOption, setSelectedOption] = useState(null);

  const giftOptions = [
    {
      id: 1,
      name: "Fin de semana de aventura",
      duration: "2 días",
      price: "210€",
      description: "Perfecta para una escapada corta y descubrir la experiencia camper",
      features: [
        "2 días de alquiler",
        "300km incluidos",
        "Seguro a todo riesgo",
        "Kit menaje"
      ],
      image: regalaAventura
    },
    {
      id: 2,
      name: "Escapada de 4 días",
      duration: "4 días",
      price: "450€",
      description: "Ideal para una escapada más larga y explorar con tranquilidad",
      features: [
        "4 días de alquiler",
        "600km incluidos",
        "Seguro a todo riesgo",
        "Kit menaje",
        "Kit ropa de cama"
      ],
      image: regalaEscapada
    },
    {
      id: 3,
      name: "Semana completa",
      duration: "7 días",
      price: "720€",
      description: "La mejor opción para vivir la experiencia camper al completo",
      features: [
        "7 días de alquiler",
        "1000km incluidos",
        "Seguro a todo riesgo",
        "Kit menaje",
        "Kit ropa de cama"
      ],
      image: regalaSemana
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-gray-50">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold text-gray-900 mb-6">
          Regala una aventura única
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Sorprende a alguien especial con la libertad de viajar en una furgoneta camper.
          El regalo perfecto para los amantes de la aventura y la naturaleza.
        </p>
      </div>

      {/* Gift Cards Grid */}
      <div className="grid md:grid-cols-3 gap-8 mb-16">
        {giftOptions.map((option) => (
          <div 
            key={option.id}
            className={`bg-white rounded-2xl shadow-sm border-2 transition-all duration-300 hover:shadow-lg ${
              selectedOption === option.id ? 'border-brand scale-105' : 'border-transparent'
            }`}
            onClick={() => setSelectedOption(option.id)}
          >
            <div className="aspect-w-16 aspect-h-9">
              <img
                src={option.image}
                alt={option.name}
                className="w-full h-48 object-cover rounded-t-2xl"
              />
            </div>
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{option.name}</h3>
                  <p className="text-gray-500">{option.duration}</p>
                </div>
                <span className="text-2xl font-bold text-brand">{option.price}</span>
              </div>
              <p className="text-gray-600 mb-4">{option.description}</p>
              <ul className="space-y-2">
                {option.features.map((feature, index) => (
                  <li key={index} className="flex items-center text-gray-600">
                    <svg className="w-5 h-5 mr-2 text-brand" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="text-center bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">¿Necesitas más información?</h2>
        <p className="text-gray-600 mb-6">
          Todas las tarjetas regalo son válidas por un año desde la fecha de compra
          y pueden ser utilizadas en cualquier temporada, sujeto a disponibilidad.
        </p>
        <div className="flex justify-center">
          <a
            href="https://wa.me/34648728151"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-[#25D366] text-white font-medium rounded-xl hover:bg-[#22BF5B] transition-all transform hover:scale-105 hover:shadow-lg"
          >
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
            </svg>
            Consultar disponibilidad
          </a>
        </div>
      </div>
    </div>
  );
}
